var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-feature-container",class:_vm.spaceLevel},[_c('div',{staticClass:"image-content"},[_c('img',{staticClass:"image-element",attrs:{"src":_vm.ad.url,"alt":_vm.ad.val},on:{"load":_vm.onImageLoad,"error":_vm.onImageError}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }